"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageLookup = exports.translationLanguages = exports.transcriptionLanguages = void 0;
exports.transcriptionLanguages = [
    { code: "en-AU", language: "English (Australia)" },
    { code: "en-GB", language: "English (Great Britain)" },
    { code: "en-IN", language: "English (India)" },
    { code: "en-IE", language: "English (Ireland)" },
    { code: "en-NZ", language: "English (New Zealand)" },
    { code: "en-AB", language: "English (Scotland)" },
    { code: "en-ZA", language: "English (South African)" },
    { code: "en-US", language: "English (US)" },
    { code: "en-WL", language: "English (Wales)" },
    { code: "af-ZA", language: "Afrikaans" },
    { code: "ar-AE", language: "Arabic (Gulf)" },
    { code: "ar-SA", language: "Arabic (Modern Standard)" },
    { code: "zh-CN", language: "Chinese (Mandarin - simplified)" },
    { code: "da-DK", language: "Danish" },
    { code: "nl-NL", language: "Dutch" },
    { code: "fa-IR", language: "Farsi" },
    { code: "fr-CA", language: "French (Canada)" },
    { code: "fr-FR", language: "French (France)" },
    { code: "de-DE", language: "German (Germany)" },
    { code: "de-CH", language: "German (Switzerland)" },
    { code: "he-IL", language: "Hebrew" },
    { code: "hi-IN", language: "Hindi (India)" },
    { code: "id-ID", language: "Indonesian" },
    { code: "it-IT", language: "Italian" },
    { code: "ja-JP", language: "Japanese" },
    { code: "ko-KR", language: "Korean" },
    { code: "ms-MY", language: "Malay" },
    { code: "pt-BR", language: "Portuguese (Brazil)" },
    { code: "pt-PT", language: "Portuguese (Portugal)" },
    { code: "ru-RU", language: "Russian" },
    { code: "es-ES", language: "Spanish (Spain)" },
    { code: "es-US", language: "Spanish (US)" },
    { code: "ta-IN", language: "Tamil" },
    { code: "te-IN", language: "Telugu" },
    { code: "th-TH", language: "Thai" },
    { code: "tr-TR", language: "Turkish" }
];
exports.translationLanguages = [
    { language: "Afrikaans", code: "af" },
    { language: "Albanian", code: "sq" },
    { language: "Amharic", code: "am" },
    { language: "Arabic", code: "ar" },
    { language: "Armenian", code: "hy" },
    { language: "Azerbaijani", code: "az" },
    { language: "Bengali", code: "bn" },
    { language: "Bosnian", code: "bs" },
    { language: "Bulgarian", code: "bg" },
    { language: "Catalan", code: "ca" },
    { language: "Chinese (Simplified)", code: "zh" },
    { language: "Chinese (Traditional)", code: "zh-TW" },
    { language: "Croatian", code: "hr" },
    { language: "Czech", code: "cs" },
    { language: "Dari", code: "fa-AF" },
    { language: "Danish", code: "da" },
    { language: "Dutch", code: "nl" },
    { language: "English", code: "en" },
    { language: "Estonian", code: "et" },
    { language: "Farsi (Persian)", code: "fa" },
    { language: "Filipino Tagalog", code: "tl" },
    { language: "Finnish", code: "fi" },
    { language: "French", code: "fr" },
    { language: "French (Canada)", code: "fr-CA" },
    { language: "Georgian", code: "ka" },
    { language: "German", code: "de" },
    { language: "Greek", code: "el" },
    { language: "Gujarati", code: "gu" },
    { language: "Haitian Creole", code: "ht" },
    { language: "Hausa", code: "ha" },
    { language: "Hebrew", code: "he" },
    { language: "Hindi", code: "hi" },
    { language: "Hungarian", code: "hu" },
    { language: "Icelandic", code: "is" },
    { language: "Indonesian", code: "id" },
    { language: "Italian", code: "it" },
    { language: "Japanese", code: "ja" },
    { language: "Kazakh", code: "kk" },
    { language: "Kannada", code: "kn" },
    { language: "Korean", code: "ko" },
    { language: "Latvian", code: "lv" },
    { language: "Lithuanian", code: "lt" },
    { language: "Macedonian", code: "mk" },
    { language: "Malay", code: "ms" },
    { language: "Malayalam", code: "ml" },
    { language: "Maltese", code: "mt" },
    { language: "Mongolian", code: "mn" },
    { language: "Norwegian", code: "no" },
    { language: "Pashto", code: "ps" },
    { language: "Polish", code: "pl" },
    { language: "Portuguese (Brazil)", code: "pt" },
    { language: "Portuguese (Portugal)", code: "pt-PT" },
    { language: "Punjabi", code: "pa" },
    { language: "Romanian", code: "ro" },
    { language: "Russian", code: "ru" },
    { language: "Serbian", code: "sr" },
    { language: "Sinhala", code: "si" },
    { language: "Slovak", code: "sk" },
    { language: "Slovenian", code: "sl" },
    { language: "Somali", code: "so" },
    { language: "Spanish", code: "es" },
    { language: "Spanish (Mexico)", code: "es-MX" },
    { language: "Swedish", code: "sv" },
    { language: "Tamil", code: "ta" },
    { language: "Telugu", code: "te" },
    { language: "Thai", code: "th" },
    { language: "Turkish", code: "tr" },
    { language: "Ukrainian", code: "uk" },
    { language: "Urdu", code: "ur" },
    { language: "Uzbek", code: "uz" },
    { language: "Vietnamese", code: "vi" },
    { language: "Welsh", code: "cy" }
];
exports.languageLookup = function (languages, code) {
    var language = languages.find(function (l) { return l.code === code; });
    if (!(language === null || language === void 0 ? void 0 : language.language) || !(language === null || language === void 0 ? void 0 : language.code)) {
        return;
    }
    return language;
};
//# sourceMappingURL=index.js.map